import { render, staticRenderFns } from "./profil.vue?vue&type=template&id=ecfb75be&scoped=true&"
import script from "./profil.vue?vue&type=script&lang=js&"
export * from "./profil.vue?vue&type=script&lang=js&"
import style0 from "./profil.vue?vue&type=style&index=0&id=ecfb75be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfb75be",
  null
  
)

export default component.exports